import React from 'react';
import css from './index.module.css';

interface Props {
  theme?: string;
}

export default function Required({ theme = '' }: Props) {
  return <span className={`${css['required']} ${css[theme]}`}>*</span>;
}
